import React, {  } from 'react';
import * as PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { IdPropType } from '../../../proptypes/basic';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
    },

    centerContent: {
        display: 'flex',
        alignItems: 'center',
    },

    autocomplete: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
    },
}));

const MailDraftHeader = ({ draftId, customerId, popup }) => {
    const classes = useStyles();

    return (
        <Grid container spacing={2} className={classes.root}>
        </Grid>
    );
};

MailDraftHeader.propTypes = {
    draftId: IdPropType.isRequired,
    customerId: IdPropType,
    popup: PropTypes.bool,
};

MailDraftHeader.defaultProps = {
    draftId: null,
    customerId: null,
    popup: false,
};

export default MailDraftHeader;
